export default "__VITE_ASSET__DAiWeXAT__"